import { useTranslation } from "react-i18next";
import CustomTable from "../../../../component/table/CustomTable"
import style from './tableIsData.module.css'
import { useEffect, useState } from "react";
import { Table } from "antd";

const TableReportIsData = (props) =>{
  const [datas, setDatas] = useState([])
  console.log("masuk");
  const { t } = useTranslation();
console.log("dataa", props.data);
  const ListColumn = 
    props?.data?.headers?.map((el, i)=>{
      return {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t(el)}
        </span>
      ),
      dataIndex: `${i}`,
      key: `${i}`,
      
    // fixed: i=== 0 ? 'left' : "",
      // render: (i) => <span>{`${i}`}</span>,

      }
    })

    
    const datas2 =[
      {name: (
      <span className="font-roboto text-lg text-[#222222]">
        {"tesssss"}
      </span>
    ),
    depot: (
      <span className="font-roboto text-lg text-[#222222]">
        {"osks"}
      </span>
    ),}
  ]
  
// console.log("datas", datas);
console.log("datas2", datas2);
    // const dataSource = props?.data?.data
    // ? props?.data?.data.map((result, indexs) => 
    // ({
    //     [`${indexs}`]: (
    //       <span className="font-roboto text-lg text-[#222222]">
    //         {result}
    //       </span>
    //     ),
    //   }))
    // : null;

    useEffect(()=>{
      // if(props.data?.data?.length >0){
        
console.log("sini1", ListColumn);
      // let listData = props.data?.data.map((el,index)=>{
      //   console.log("sini2", el);
let listData=[]
      // })
      let dat =props?.data?.data
      for(let i = 0; i < dat.length; i++){
        const element = dat[i];
        let datas2={}
        for(let j = 0; j < element.length; j++){
          const element2 = element[j];
          // console.log("data", j, " daa", element2?.value)
          // datas2[`${j}`] = (
          //     <span className="font-roboto text-lg text-[#222222]">
          //       {element2?.value}
          //     </span>
          //   )
          // datas2[j] = (
          //   <span key={i-j} className="font-roboto text-lg text-[#222222]">
          //     {element2?.value}
          //   </span>
          // );
            datas2[`${j}`] = (
              <span className="font-roboto text-lg text-[#222222]">
                {element2?.value}
              </span>
            )
        }
        console.log("datas 2", [datas2])
        // setDatas([datas2])
        listData.push(datas2)
      }

      console.log("sini6", listData);
      setDatas(listData)
    
    },[props?.data])
  
  return(
    <>
    <div className={style.tableContainer}>
          <CustomTable columns={ListColumn} 
          data={datas} 
          scroll={{
            x: 5000,
            y: 500,
          }}
          isnotPaging={true}
      summary={() => (
        <Table.Summary fixed className="bg-red-200">
          <Table.Summary.Row className="bg-[#F7D1D2] font-roboto font-medium text-lg text-[#CF0000]">
            {
              props?.data?.grand_total[0]?.map((el,i)=>{
                return(
                  <>
                  <Table.Summary.Cell index={i}>{el?.value}</Table.Summary.Cell>
                  </>
                )
              })
            }
            {/* <Table.Summary.Cell index={0}>Summary</Table.Summary.Cell>
            <Table.Summary.Cell index={1}>This is a summary content</Table.Summary.Cell> */}
          </Table.Summary.Row>
        </Table.Summary>
      )}
          />
          {/* <div className={style.containerPagination + " mt-[-45px]"}>
            <CustomPaging
              idLimit="ddlrowsperpagemustselllist"
              idPagination="btnpaginationmustselllist"
              size="small"
              current={page}
              defaultCurrent={page}
              pageSize={limit}
              total={initiate && initiate?.count_data}
              pageSizeOptions={initiate && initiate?.valid_limit}
              onShowSizeChange={() => handlePagination()}
              handlePaging={(a,b) => handlePagination(a,b)}
              title={t("COMMON:ROW_PAGE")}
            />
          </div> */}
        </div>
    </>
  )
}

export default TableReportIsData